





















import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import GlobalErrorSnackBar from "@/components/GlobalErrorSnackBar.vue";
import Loading from "@/components/Loading.vue";

export default Vue.extend({
  components: { GlobalErrorSnackBar, Loading },
  data() {
    return {
      loading: false,
      docs: [] as any[],
      doc: null as any,
      docId: this.$route.params.id || null,
    };
  },
  async created() {
    this.loading = true;
    console.log("docId:", this.docId);

    try {
      if (this.docId) {
        // Load single doc by ID
        const doc = await coreApiClient.call("docs", "findById", { id: this.docId });
        if (doc && !doc.disabled) {
          this.doc = doc;
        }
      }
    } catch (error) {
      console.error("Error loading docs:", error);
    } finally {
      this.loading = false;
    }
  },
});
